import { MDBIcon, MDBTextArea } from "mdb-react-ui-kit";
import { useContext } from "react";
import useResumeExperiencesHandlers from "../../../context/resume/hooks/resume-experiences-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function ExperienceRoleItem(
    {
        item,
        parentOrder,
        numberOfItems,
    }
) {
    const { translations } = useContext(TranslationContext);
    const { handleChangeRole, handleRemoveRole, handleMoveRoleDown, handleMoveRoleUp } = useResumeExperiencesHandlers();

    return (
        <div className="d-flex mb-2 input-acv">
            <MDBTextArea
                type="text"
                className="form-control-input"
                value={ item.text || "" }
                placeholder="dont X jours en tant que X"
                onChange={
                    ( event ) =>
                        handleChangeRole( { ...item, text: event.target.value }, parentOrder )
                }
            />
            <div className="icons-container d-flex align-items-center" style={ { marginLeft: 'auto', width: '50px' } }>
                <MDBIcon
                    fas
                    icon="arrow-up"
                    className="m-1"
                    role="button"
                    onClick={ () => item.order !== 0 && handleMoveRoleUp( item, parentOrder ) }
                    style={ { cursor: item.order !== 0 ? "pointer" : "default" } }
                    color={ item.order !== 0 ? "" : "muted" }
                />
                <MDBIcon
                    fas
                    icon="arrow-down"
                    className="m-1"
                    role="button"
                    onClick={ () => item.order !== numberOfItems - 1 && handleMoveRoleDown( item, parentOrder ) }
                    style={ { cursor: item.order !== numberOfItems - 1 ? "pointer" : "default" } }
                    color={ item.order !== numberOfItems - 1 ? "" : "muted" }
                />
                <MDBIcon
                    far
                    icon="trash-alt"
                    className="m-2"
                    role="button"
                    onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemoveRole( item, parentOrder ) }
                    style={ { cursor: 'pointer' } }
                />
            </div>
        </div>
    );
}